// @flow

export const noop = (): void => undefined;
